import QUANTROOT_EXT_1 from "./QUANTROOT_EXT_1";
export default {
  QUANTROOT_EXT_1,
};
